function updateUrlParameter(uri, key, value) {
	
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
		separator = uri.indexOf('?') !== -1 ? "&" : "?";
	
	if (value === null || key === null) {
		return uri;
	}
		
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
		
	} else {
		return uri + separator + key + "=" + value;
	}
	
}

export default updateUrlParameter;